import moment, { Moment } from 'moment-timezone';
import { parseDate } from './formatters';

const MAX_WEEKS = 40;

const getDateOfConception = (date: Moment) => {
	return date
		.subtract(40, 'weeks')
		.set({ hours: 0, minutes: 0, seconds: 0 })
		.format('YYYY-MM-DD');
};

export const getDateDifferenceMoment = ({
	dateOfBirth,
	estimatedDateOfBirth,
}: {
	dateOfBirth?: Moment;
	estimatedDateOfBirth: Moment;
}) => {
	if (!dateOfBirth && !estimatedDateOfBirth) {
		return {
			weeks: '0',
			days: '0',
		};
	}

	if (
		(dateOfBirth && !dateOfBirth?.isValid()) ||
		(estimatedDateOfBirth && !estimatedDateOfBirth?.isValid())
	) {
		return {
			weeks: '0',
			days: '0',
		};
	}

	//K DNESNIMU DNI
	const endDate = dateOfBirth ? dateOfBirth : moment();
	const end = endDate
		.set({ hours: 0, minutes: 0, seconds: 0 })
		.format('YYYY-MM-DD');
	const start = getDateOfConception(estimatedDateOfBirth);

	const formattedEnd = moment.utc(end);
	const formattedStart = moment.utc(start);

	const duration = moment.duration(formattedEnd.diff(formattedStart));
	const days = duration.asDays();
	const weeks = Math.floor(days / 7);

	if (days % 7 > 0) {
		return {
			weeks: String(weeks),
			days: String(Math.floor(days % 7)),
		};
	}

	return {
		weeks: String(weeks),
		days: '0',
	};
};

export const getDateDifference = ({
	date,
	froMDate,
}: {
	date?: Moment;
	froMDate?: Date;
}) => {
	const maxDate = moment().add(MAX_WEEKS, 'weeks');

	const estimatedStartOfPregnancy = moment(date)
		.subtract(MAX_WEEKS, 'weeks')
		.format('D-MM-yyyy');

	if (!date) {
		return { weeks: '', days: '', maxDate };
	}

	const date1 = new Date(
		parseDate({
			input: estimatedStartOfPregnancy,
			format: 'dd.mm.yyyy',
		}),
	);

	const date2 = froMDate ? new Date(froMDate) : new Date();

	// @ts-ignore
	const timeDifference = Math.abs(date2 - date1);
	const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

	const finalWeeks = Math.floor(daysDifference / 7);
	const finalDays = 0;

	if (
		date1.getDay() !== date2.getDay() ||
		date1.getMonth() !== date2.getMonth()
	) {
		if (daysDifference % 7 > 0) {
			return {
				weeks: String(finalWeeks - 1),
				days: String(7 - (daysDifference % 7)),
			};
		}
	}

	return {
		weeks: String(finalWeeks),
		days: String(finalDays),
	};
};
